/* IMPORTS ------------------------------------------------------------------------------------- */
// PLUGINS
import { v4 as uuid } from 'uuid';
import { writable } from 'svelte/store';
/* INTERFACES --------------------------------------------------------------------------------- */
// Create a writable store for loaders
export const LOADERS = writable([]);
// Function to remove a loader from the store
export const removeLoader = (key) => {
    LOADERS.update((loaders) => loaders.filter(loader => loader !== key));
};
// Function to add a loader to the store
export const addLoader = () => {
    const KEY = uuid();
    LOADERS.update((loaders) => [...loaders, KEY]);
    return KEY;
};
